import { ApiService } from 'src/app/services/api.service';
import { MeetingRoomUploadService } from 'src/app/services/meeting-room-upload.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { APIs } from '../config/api.constant';
import { AppConstant } from '../config/app.constant';

@Injectable({
  providedIn: 'root'
})
export class MeetingService {
  constructor(
    private apiService: ApiService,
    private meetingRoomUploadService: MeetingRoomUploadService
  ) {}

  uploadImage(event) {
    return new Promise((resolve, reject) => {
      let url: string | ArrayBuffer;
      console.log('came here 1', event);
      if (event.target.files && event.target.files[0]) {
        console.log(event.target.files[0].size);
        var reader = new FileReader();
        reader.readAsDataURL(event.target.files[0]);
        reader.onload = (event) => {
          console.log('event', event);
          url = event.target.result;
          resolve(url);
        };
      }
    });
  }

  getCLACreditDetails(): Observable<any> {
    return this.apiService.get(APIs.getCLACreditDetails).pipe(map(response => {
      return response;
    }))
  }

  updateMeetingRoom(data) {
    return this.apiService.post(APIs.updateMeetingRoomDetail, data).pipe(
      map((res) => {

        return res;
      })
    );
  }

  /** Update meeting room with multipart FormData (images as files). Used by main and company meeting room. Content-Type omitted via MeetingRoomUploadService. */
  updateMeetingRoomFormData(formData: FormData): Observable<any> {
    return this.meetingRoomUploadService.postFormData(APIs.updateMeetingRoomDetail, formData).pipe(
      map((res) => res)
    );
  }

  AddMeetingRoom(data) {
    return this.apiService.post(APIs.saveMeetingRoom, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  /** Create meeting room with multipart FormData (images as files). Used by main and company meeting room. Content-Type omitted via MeetingRoomUploadService. */
  AddMeetingRoomFormData(formData: FormData): Observable<any> {
    return this.meetingRoomUploadService.postFormData(APIs.saveMeetingRoom, formData).pipe(
      map((res) => res)
    );
  }

  getAllAmenities() {
    return this.apiService.get(APIs.getAllAmenities).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getAllParkMeetingRooms(id: string, paymentStatus, parkTenantId): Observable<any> {
    return this.apiService.get(APIs.listAllParkMeetingRoom + '?parkId=' + id + '&paymentStatus=' + paymentStatus + '&parkTenantId=' + parkTenantId).pipe(map(response => {
      return response;
    }));
  }

  getMeetingRoomDetails(id: string): Observable<any> {
    return this.apiService.get(APIs.detailsParkMeetingRoom + '?parkMeetingRoomId=' + id + '&isPortal=web').pipe(map(response => {
      return response.data;
    }));
  }

  deleteParkMeetingRoom(body): Observable<any> {
    return this.apiService.post(APIs.deleteParkMeetingRoom, body).pipe(map(response => {
      return response;
    }));
  }

  bookNewMeetingRoom(body): Observable<any> {
    return this.apiService.post(APIs.createParkMeetingRoomCalendar, body).pipe(map(response => {
      return response;
    }));
  }

  getAllMeetingRoomBlockData(data) {
    return this.apiService.post(APIs.getAllBlockDatesMeeting, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getMeetingRoomTimeLine(data) {
    return this.apiService.post(APIs.getMeetingRoomTimeLine, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  // cancelBlockedMeetingRoom(data): Observable<any> {
  //   return this.apiService.post(APIs.cancelBlockedMeeting, data).pipe(map(response => {
  //     return response;
  //   }));
  // }

  cancelBlockedMeetingRoom(id: string): Observable<any> {
    return this.apiService.delete(APIs.cancelBlockedMeeting + '?meetingroomCalendarId=' + id).pipe(map(response => {
      return response;
    }));
  }

  // cancelBookedMeetingRoom(id: string): Observable<any> {
  //   return this.apiService.delete(APIs.cancelBookedMeeting + '?bookingId=' + id).pipe(map(response => {
  //     return response;
  //   }));
  // }

  bookedParkMeetingRooms(data): Observable<any> {
    return this.apiService.post(APIs.bookedMeetingRoomList, data).pipe(map(response => {
      return response;
    }));
  }

  cancelBookedMeetingRoom(data) {
    return this.apiService.put(APIs.cancelBookedMeeting, data).pipe(map((res) => {
      return res;
    }));
  }

  getMyCompanyDetails(parkTenantId: string, parkId: string): Observable<any> {
    return this.apiService.get(`${APIs.getMyCompanyDetails}?parkTenantId=${parkTenantId}&parkId=${parkId}`).pipe(map(response => {
      return response;
    }))
  }
}
